import React from 'react'
import Pt from 'prop-types'
import { Panel } from 'react-bootstrap'

export default function ErrorResponse({ response }) {
  const panelTitle = (
    <h2>An Error Has Occurred &mdash; {response.status} &mdash; {response.statusText}</h2>
  )

  return (
    <section className="container">
      <Panel bsStyle="danger" header={panelTitle}>
        <Panel.Body>
          {response.status === 403 && (
            <div>
              <p>
                Your request resulted in an access denied error. You may not
                have sufficient permissions to perform the requested action.
              </p>

              <p>
                If you are not logged in, try logging into your account and trying
                again.
              </p>
            </div>
          )}

          <hr />

          <p>
            If you continue to experience problems, please contact our helpdesk
            by emailing us at <a href="mailto:support@infinite.net.au">
            support@infinite.net.au</a> or calling us during business hours on
            1300 790 337.
          </p>
        </Panel.Body>
      </Panel>
    </section>
  )
}

ErrorResponse.propTypes = {
  response: Pt.shape({
    status: Pt.number.isRequired,
    statusText: Pt.string.isRequired,
  }).isRequired,
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/components/Error/ErrorResponse.jsx